import { render } from "./visualEdit.vue?vue&type=template&id=c6c4b4b8"
import script from "./visualEdit.vue?vue&type=script&lang=js"
export * from "./visualEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__